import ModalAddForm from './modal-add-form';
import ModalConsent from './modal-consent';
import ModalFillOnThisDevice from './modal-fill-on-this-device';
import ModalNoDobOrEmailOrSms from './modal-no-dob-or-email-or-sms';
import ModalRemoveAllAssignedForms from './modal-remove-all-assigned-forms';
import ModalScanQrCode from './modal-scan-qr-code';
import ModalSelectPatient from './modal-select-patient';
import ModalSendLink from './modal-send-link';
import ModalUnassignForm from './modal-unassign-form';

export default function FormsModals() {
    return (
        <>
            <ModalSelectPatient />
            <ModalNoDobOrEmailOrSms />
            <ModalScanQrCode />
            <ModalSendLink />
            <ModalRemoveAllAssignedForms />
            <ModalFillOnThisDevice />
            <ModalAddForm />
            <ModalUnassignForm />
            <ModalConsent />
        </>
    );
}
